import { render, staticRenderFns } from "./Totop.vue?vue&type=template&id=77b2683a&scoped=true&"
import script from "./Totop.vue?vue&type=script&lang=js&"
export * from "./Totop.vue?vue&type=script&lang=js&"
import style0 from "./Totop.vue?vue&type=style&index=0&id=77b2683a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2683a",
  null
  
)

export default component.exports